import React from "react"

import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../../render/table/table-cell"
import formatDate from "../../../../../../gd/format/date"
import {isBulkSelection} from "../../../../../../gd/right-click-menu"
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view"
import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type"
import formatDateTime from "../../../../../../gd/format/date-time"

// const debug = "FieldDatetime_TableCellCalculated"
const debug = false

export default class FieldDatetime_TableCellCalculated extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered       : false,
            showPopover     : false
        }
    }

    get canEdit():boolean {
        if (this.props.manager.isReadOnly) {
            return false
        }

        return this.props.field.canEdit(this.props.listItem.item)
    }

    onMouseEnter = () => {
        if (!this.canEdit) {
            return
        }

        if (!this.state.isHovered) {
            this.setState({
                isHovered   : true
            })
        }
    }

    onMouseLeave = () => {
        if (this.state.showPopover) {
            return
        }

        if (this.state.isHovered) {
            this.setState({
                isHovered   : false
            })
        }
    }

    async onValueChange(value: Moment | null, hidePopover: boolean = true) {

        if (!this.props.field.fieldParams.tableCellOnValueChange) {
            console.error("#sdgsg Not implemented")
            return
        }

        await this.props.field.fieldParams.tableCellOnValueChange(this.props.listItem, value, this.props.manager)

        hidePopover && this.hidePopover()
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }
        if (!this.canEdit) {
            return
        }

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    onDeleteClick = async (e:React.MouseEvent)=>{
        if (isBulkSelection(e)) {
            return
        }
        e.stopPropagation()

        if (!this.props.field.fieldParams.tableCellOnValueChange) {
            console.error("#dgsgs Not implemented ")
            return
        }

        await this.props.field.fieldParams.tableCellOnValueChange(this.props.listItem, null, this.props.manager)

        FieldProto_updateView(this.props.manager, this.props.field)
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderHovered() {
        const value = this.props.field.getViewValue(this.props.listItem.item)
        const displayValue = this.props.field.getDisplayValue(value)

        const showValue = !!displayValue

        return (
            <div className      = "cell-flex is-hovered"
                 style          = {getTableCellStyle(this.props)}
                 onMouseEnter   = {this.onMouseEnter}
                 onMouseLeave   = {this.onMouseLeave}>
                <div className  = "ui5-field-editable size-small is-hovered w-100-percent h-100-percent"
                     onClick    = {this.onClick}>

                    {showValue &&
                        <div className="ui5-txt-less-important-small w-100-percent flex-row-left-center txt-truncate">
                            {displayValue}
                        </div>}

                    {!showValue &&
                        <div className="ui5-txt-less-important-small w-100-percent flex-row-left-center txt-truncate">
                            {this.props.field.label}
                        </div>}

                    <div className="buttons flex-no-shrink">
                        {showValue &&
                            <div className="btn-reset" onClick={this.onDeleteClick}/>}
                        <div className="btn-arrow"/>
                    </div>

                </div>

                {this.state.showPopover &&
                    <this.props.field.components.PopoverMenu {...this.props} parent={this}/>
                }
            </div>
        )
    }

    renderNotHovered() {
        const calculatedValues: ItemModelV2_CalculatedValues | undefined = this.props.listItem.calculated.dataByAggregateFunction[this.props.field.fieldId as keyof {}]?.[this.props.column.aggregateFunction!]
        const showSummaryView   = this.props.listItem.view.isCollapsed &&
            calculatedValues &&
            (!!calculatedValues.total.moment || !!calculatedValues.total.momentRange)

        debug && console.log(debug, "renderNotHovered", this.props.listItem.debugName, showSummaryView, calculatedValues)

        let notHoveredContent
        if (showSummaryView) {
            let label
            if (calculatedValues.total.momentRange) {
                label = '{0} - {1}'.f(formatDateTime(calculatedValues.total.momentRange.start), formatDateTime(calculatedValues.total.momentRange.end))
            } else {
                label = formatDate(calculatedValues.total.moment)
            }

            const iconClasses = Classes("ui5-ico-12 m-r-5 m-t-1", this.props.column.aggregator?.icon)
            notHoveredContent = (
                <>
                    <div className={iconClasses}/>
                    <div className="ui5-txt-less-important-small">
                        {label}
                    </div>
                </>
            )
        } else {
            const value = this.props.field.getViewValue(this.props.listItem.item)
            const displayValue = this.props.field.getDisplayValue(value)

            notHoveredContent = (
                <>
                    {!!displayValue &&
                        <div className="ui5-txt-less-important-small w-100-percent flex-row-left-center txt-truncate">
                            {displayValue}
                        </div>}
                </>
            )
        }

        return (
            <div className      = "cell-flex border-1px-transparent"
                 style          = {getTableCellStyle(this.props)}
                 onMouseEnter   = {this.onMouseEnter}
                 onMouseLeave   = {this.onMouseLeave}>

                {notHoveredContent}
            </div>
        )
    }

    render() {
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered) {
            return this.renderHovered()
        } else {
            return this.renderNotHovered()
        }
    }
}



